<script setup lang="ts">
  import SidebarLink from '~/components/UI/Utilities/SidebarLink.vue';
  import SidebarSection from '~/components/UI/Utilities/SidebarSection.vue';
  import { Role } from '~/types/auth';
  const { isExpenseEnabled, role, isDatabaseAdminModuleEnabled } = useAuth();
  // Gated on the database_admin role alone, same as the backend's
  // database_admin_only decorator and the special-cased route check in
  // routeController.ts.
  const canAccessDatabaseAdmin = computed(
    () => isDatabaseAdminModuleEnabled.value && role.value.includes(Role.DatabaseAdmin)
  );
  // A database_admin-only user (no admin / utilities_access) has no access to
  // any of the other utilities tools - only show those sections to users who
  // actually hold one of those roles.
  const canAccessGeneralUtilities = computed(
    () => role.value.includes(Role.Admin) || role.value.includes(Role.UtilitiesAccess)
  );
</script>

<template>
  <div class="flex min-h-[calc(100vh-55px)]">
    <div class="!w-[300px] px-2 border-r border-zinc-200 sticky top-[55px] h-[calc(100vh-55px)] overflow-y-auto pb-5">
      <template v-if="canAccessGeneralUtilities">
        <SidebarSection title="Tally Integration">
          <SidebarLink :to="'/utilities'" label="Export to Tally - Income" />
          <SidebarLink
            v-if="isExpenseEnabled"
            :to="'/utilities/export_tally_expense'"
            label="Export to Tally - Expense"
          />
          <SidebarLink
            v-if="isExpenseEnabled"
            :to="'/utilities/expense_reconciliation'"
            label="Expense Reconciliation"
          />
          <SidebarLink
            v-if="isExpenseEnabled"
            :to="'/utilities/expense_reconciliation_status'"
            label="Expense Reconciliation Status"
          />
        </SidebarSection>
        <SidebarSection title="Imports">
          <SidebarLink :to="'/utilities/import_donations'" label="Import Donations" />
          <SidebarLink v-if="isExpenseEnabled" :to="'/utilities/import_payee'" label="Import Payee" />
          <SidebarLink :to="'/utilities/import_ledgers'" label="Import Ledgers" />
          <SidebarLink v-if="isExpenseEnabled" :to="'/utilities/import_payments'" label="Import Payments" />
        </SidebarSection>
        <SidebarSection title="Exports">
          <!-- <SidebarLink :to="'/utilities/statutory_reports'" label="Form 10BD" /> -->
          <SidebarLink :to="'/utilities/form113'" label="Form 113" />
          <SidebarLink :to="'/utilities/10be_emailer'" label="10BE Emailer" />
          <SidebarLink :to="'/utilities/tax_audit'" label="Tax Audit - Substantial Donors" />
          <SidebarLink :to="'/utilities/download_formats'" label="Download Formats" />
          <SidebarLink :to="'/utilities/grant_wise_attachments_download'" label="Grant Wise Attachments Download" />
        </SidebarSection>
      </template>
      <SidebarSection v-if="canAccessDatabaseAdmin" title="Database Admin">
        <SidebarLink :to="'/utilities/database_data_export'" label="Database Data Export" />
        <SidebarLink :to="'/utilities/database_data_export_audit_log'" label="Database Data Export Audit Log" />
      </SidebarSection>
    </div>
    <div class="w-[calc(100%-300px)]">
      <slot />
    </div>
  </div>
</template>
